import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconCamera3: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconCamera3"><Path d="M2.5 3.5H21.5V20.5H2.5V3.5Z" stroke="currentColor"/><Path d="M15.5 12C15.5 13.933 13.933 15.5 12 15.5C10.067 15.5 8.5 13.933 8.5 12C8.5 10.067 10.067 8.5 12 8.5C13.933 8.5 15.5 10.067 15.5 12Z" stroke="currentColor"/><Path d="M17.5 7.5V7.49M17.75 7.5C17.75 7.63807 17.6381 7.75 17.5 7.75C17.3619 7.75 17.25 7.63807 17.25 7.5C17.25 7.36193 17.3619 7.25 17.5 7.25C17.6381 7.25 17.75 7.36193 17.75 7.5Z" stroke="currentColor" strokeLinecap="round"/></CentralIconBase>;
});

export default IconCamera3;
